import axios from "../axios";
import * as endPoints from "../endpoints";

export const UserLogin = async (data) =>
  Promise.resolve(axios.post(endPoints.userLogin, data));
